import { ParsedError } from './ParsedError'

export class HttpError extends ParsedError {
  override readonly tag = 'http'

  override readonly attributes

  constructor(
    statusCode: number | undefined,
    statusMessage: string | undefined,
    customAttributes: Record<string, unknown>,
  ) {
    super()
    this.attributes = {
      ...customAttributes,
      statusCode,
      statusMessage,
      origin: this.getErrorOrigin(statusCode),
    }
  }

  private getErrorOrigin(statusCode: number | undefined) {
    if (!statusCode) {
      return 'unknown'
    }
    if (statusCode >= 500) {
      return 'server'
    }
    if (statusCode === 403) {
      return 'authentication'
    }

    return 'client'
  }
}
